import React from "react";
import CatalogoPageLayout from "./CatalogoPageLayout";

const CatalogoPromocionesPage: React.FC = () => (
  <CatalogoPageLayout
    title="Promociones"
    description="Configurá promociones por horario, sucursal o códigos especiales para el POS y pedidos web."
    helperText="Acá vas a poder combinar descuentos generales y listas de artículos elegibles."
  />
);

export default CatalogoPromocionesPage;
